
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","stroke":"currentColor","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.813 13.188H5.186a.469.469 0 000 .937h5.625a.469.469 0 000-.938zM10.813 9.438H5.186a.469.469 0 000 .937h5.625a.469.469 0 000-.938zM10.813 11.313H5.186a.469.469 0 000 .937h5.625a.469.469 0 000-.938zM10.344 0H3.78v4.063h6.563V0z"}}),_c('path',{attrs:{"d":"M15.863 2.637l-2.5-2.5A.469.469 0 0013.03 0h-1.75v4.531c0 .26-.21.469-.469.469h-7.5a.469.469 0 01-.468-.469V0H.469A.469.469 0 000 .469V15.53c0 .26.21.469.469.469H15.53c.26 0 .469-.21.469-.469V2.97a.469.469 0 00-.137-.332zm-3.644 12.425H3.78V8.5h8.438v6.563z"}})])
          )
        }
      }
    